<script
  src="../../../../../../../../../../../Downloads/_usun/dobry-agent-image-delete-backend-errors/dobry-agent-facility.service.ts"></script>
<div class="facility-details-view-container"
     *ngIf="facilityDobryAgentObject"
     fxLayout="column" fxLayoutGap="15px">
  <div class="id-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + facilityDobryAgentObject?.status?.color">
      <mat-label>Status placówki</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="facilityDobryAgentObject?.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).facility.write" (click)="modify()" mat-stroked-button
            color="primary">
      <mat-icon>create</mat-icon>
      <span> Edytuj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Dane placówki</h3>
        <div fxLayout="column">
          <app-detail fxFlex="100" header="Nazwa" [value]="facilityDobryAgentObject?.name">
          </app-detail>
          <app-detail fxFlex="100" header="Link do placówki">
            <a class="default-link" [href]="facilityDobryAgentObject?.url"
               target="_blank">{{ facilityDobryAgentObject?.url }}</a>
          </app-detail>
          <app-detail fxFlex="100" header="Opis">
            <span [innerHTML]="facilityDobryAgentObject?.description"></span>
          </app-detail>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="50" header="Typ placówki" [value]="facilityDobryAgentObject?.type?.name"></app-detail>
          <app-detail fxFlex="50" header="Obsługa" [value]="facilityDobryAgentObject?.serviceType?.name "></app-detail>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="50" header="Nr telefonu" [value]="facilityDobryAgentObject?.phoneNumber"></app-detail>
          <app-detail fxFlex="50" header="Adres e-mail" [value]="facilityDobryAgentObject?.email"></app-detail>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="100" header="Status placówki"
                      [value]="facilityDobryAgentObject?.status?.name"></app-detail>
        </div>

      </mat-card>
      <app-detail-address header="Adres placówki" [address]="facilityDobryAgentObject?.address"></app-detail-address>
      <mat-card>
        <h3>Godziny otwarcia</h3>

        <div fxLayout="column" fxLayoutGap="8px" *ngIf="getOpeningHoursItems().length > 0; else noOpenHours">
          <div
            class="opening-hours-row"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            *ngFor="let day of getOpeningHoursItems()"
          >
            <div class="opening-hours-row__day">
              {{ day.label }}
            </div>

            <div class="opening-hours-row__hours" [class.opening-hours-row__hours--closed]="day.closed">
              <ng-container *ngIf="!day.closed; else closedDay">
                {{ day.openTime }} - {{ day.closeTime }}
              </ng-container>

              <ng-template #closedDay>
                nieczynne
              </ng-template>
            </div>
          </div>
        </div>

        <ng-template #noOpenHours>
          <app-detail header="Godziny otwarcia" value="Brak danych"></app-detail>
        </ng-template>

        <h3>Daty nieobecności</h3>
        <div

          fxLayout="row wrap"
          fxLayoutGap="8px"
          class="days-off-list">
          <ng-container *ngIf="facilityDobryAgentObject?.daysOffFromWork.length ; else noDaysOffFromWork">
            <mat-chip
              *ngFor="let control of facilityDobryAgentObject.daysOffFromWork; let i = index"
            >
              {{ control }}
            </mat-chip>
          </ng-container>
          <ng-template #noDaysOffFromWork>
            Brak zaplanowanych nieobecności
          </ng-template>

        </div>
      </mat-card>
      <mat-card>
        <h3>Wizytówka google</h3>
        <div fxLayout="column" fxLayoutGap="15px">
          <app-detail fxFlex="100" header="Google Place ID"
                      [value]="facilityDobryAgentObject?.googlePlaceId "></app-detail>
          <app-detail fxFlex="100" header="Google url">
            <a class="default-link" [href]="facilityDobryAgentObject?.googleBusinessUrl"
               target="_blank">{{ facilityDobryAgentObject?.googleBusinessUrl }}</a>
          </app-detail>
        </div>
      </mat-card>
      <mat-card>
        <h3>SEO</h3>
        <div fxLayout="column" fxLayoutGap="15px">
          <app-detail fxFlex="100" header="SEO Slug" [value]="facilityDobryAgentObject?.seoSlug "></app-detail>
          <app-detail fxFlex="100" header="SEO Title" [value]="facilityDobryAgentObject?.seoTitle "></app-detail>
          <app-detail fxFlex="100" header="SEO Description"
                      [value]="facilityDobryAgentObject?.seoDescription "></app-detail>
          <app-detail fxFlex="100" header="SEO Keywords"
                      [value]="facilityDobryAgentObject?.seoDescription "></app-detail>
        </div>
      </mat-card>
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Zdjęcia</h3>

        <div fxLayout="column" fxLayoutGap="10px">

          <img
            *ngIf="facilityDobryAgentObject?.featuredImage?.src"
            class="facility-featured-image"
            [src]="getImageUrl(facilityDobryAgentObject?.featuredImage?.src)"
            [srcset]="getImageSrcset(facilityDobryAgentObject?.featuredImage?.srcset)"
            [attr.width]="facilityDobryAgentObject?.featuredImage?.width"
            [attr.height]="facilityDobryAgentObject?.featuredImage?.height"
            alt="Zdjęcie placówki"
          />

          <div
            *ngIf="facilityDobryAgentObject?.galleryImage?.length"
            class="facility-gallery"
            fxLayout="row wrap"
            fxLayoutGap="8px"
          >
            <div
              class="facility-gallery-item"
              *ngFor="let photo of facilityDobryAgentObject.galleryImage"
            >
              <img
                *ngIf="photo?.src"
                class="facility-gallery-image"
                [src]="getImageUrl(photo.src)"
                [srcset]="getImageSrcset(photo.srcset)"
                [attr.width]="photo.width"
                [attr.height]="photo.height"
                alt="Zdjęcie placówki"
              />
            </div>
          </div>

          <app-detail
            *ngIf="!facilityDobryAgentObject?.featuredImage?.src && !facilityDobryAgentObject?.galleryImage?.length"
            header="Zdjęcia"
            value="Brak zdjęć">
          </app-detail>

        </div>
      </mat-card>
      <mat-card>
        <h3>Dodatkowe</h3>

        <div fxLayout="column" fxLayoutGap="10px">
          <app-detail fxFlex="100" header="Podkategorie">
            <mat-chip-list *ngIf="getActiveSubCategories().length > 0; else noSubCategories">
              <mat-chip
                color="accent"
                selected
                *ngFor="let subCategory of getActiveSubCategories()"
              >
                {{ subCategory.name }}
              </mat-chip>
            </mat-chip-list>
            <ng-template #noSubCategories>
              Brak danych
            </ng-template>
          </app-detail>
        </div>
        <div fxLayout="column" fxLayoutGap="10px">
          <app-detail fxFlex="100" header="Towarzystwa ubepieczeniowe">
            <mat-chip-list *ngIf="getInsuranceCompanies().length > 0; else noInsuranceCompany">
              <mat-chip
                color="accent"
                selected
                *ngFor="let insuranceCompany of getInsuranceCompanies()"
              >
                {{ insuranceCompany.name }}
              </mat-chip>
            </mat-chip-list>
            <ng-template #noInsuranceCompany>
              Brak danych
            </ng-template>
          </app-detail>
        </div>
        <div fxLayout="column" fxLayoutGap="10px">
          <app-detail fxFlex="100" header="Metody płatności">
            <mat-chip-list *ngIf="getActivePaymentMethods().length > 0; else noPaymentMethods">
              <mat-chip
                color="accent"
                selected
                *ngFor="let method of getActivePaymentMethods()"
              >
                <mat-icon class="payment-method-icon">
                  {{ getPaymentMethodIcon(method) }}
                </mat-icon>
                {{ method.name }}
              </mat-chip>
            </mat-chip-list>

            <ng-template #noPaymentMethods>
              Brak danych
            </ng-template>
          </app-detail>
        </div>
        <h3>Udogodnienia</h3>
        <div fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="33" header="Parking przy placówce"
                      [value]="facilityDobryAgentObject?.parking  ? 'TAK' : 'NIE' "></app-detail>
          <app-detail fxFlex="33" header="Udogodnienia dla niepełnosprawnych"
                      [value]="facilityDobryAgentObject?.accessibilityFeatures  ? 'TAK' : 'NIE' "></app-detail>
          <app-detail fxFlex="33" header="Najlepsi agenci"
                      [value]="facilityDobryAgentObject?.bestAgents ? 'TAK' : 'NIE' "></app-detail>
        </div>
      </mat-card>
      <mat-card>
        <h3>Strona www</h3>
        <div fxLayout="column" fxLayoutGap="15px">
          <app-detail fxFlex="100" header="Facebook">
            <a class="default-link" [href]="facilityDobryAgentObject?.facebook"
               target="_blank">{{ facilityDobryAgentObject?.facebook }}</a>
          </app-detail>
          <app-detail fxFlex="100" header="Strona www">
            <a class="default-link" [href]="facilityDobryAgentObject?.website"
               target="_blank">{{ facilityDobryAgentObject?.website }}</a>
          </app-detail>
        </div>
      </mat-card>
      <mat-card>
        <h3>Produkty Chronie.pl</h3>
        <div fxLayout="column" fxLayoutGap="15px">
          <!--          <ng-container *ngFor="let partner of partnerFacility.partners">-->
          <!--            <app-detail fxFlex="100" header="Kod zniżkowy"-->
          <!--                        [value]="partner?.mainAffiliateCode"></app-detail>-->
          <app-detail fxFlex="100" header="Kod zniżkowy"
                      [value]="facilityDobryAgentObject.affiliateCode"></app-detail>
          <ng-container *ngFor="let chronieProduct of facilityDobryAgentObject.chronieInsuranceProducts">
            <app-detail fxFlex="100" [header]="chronieProduct.title">
              <a
                class="default-link"
                [href]="getChronieUrl(chronieProduct?.chronieUrl)"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ chronieProduct?.chronieUrl }}
              </a>
            </app-detail>
          </ng-container>
          <!--          </ng-container>-->
        </div>
      </mat-card>
    </div>
  </div>
</div>
